// Fallback visual si el API aún no respondió. La tasa viva la define
// MERCADOPAGO_PROCESSING_FEE_PERCENT ("2,35" = 2,35%) y llega en GET /api/campaign.
export const MERCADOPAGO_PROCESSING_FEE_RATE = 0.0235

export function effectiveFeeRate(rate) {
  const parsed = Number(rate)
  return parsed > 0 ? parsed : MERCADOPAGO_PROCESSING_FEE_RATE
}

export function netForGross(grossAmount, rate) {
  const feeRate = effectiveFeeRate(rate)
  return Math.floor(grossAmount * (1 - feeRate))
}

export function grossForNet(netAmount, rate) {
  const feeRate = effectiveFeeRate(rate)
  const net = Math.trunc(netAmount)
  if (feeRate <= 0) return net

  let gross = Math.ceil(net / (1 - feeRate))
  while (netForGross(gross, feeRate) < net) {
    gross += 1
  }
  return gross
}

export function processingFeeAmount(netAmount, rate) {
  return grossForNet(netAmount, rate) - Math.trunc(netAmount)
}

export function chargeAmount(netAmount, coverProcessingFee, rate) {
  if (!coverProcessingFee) return netAmount
  return netAmount + processingFeeAmount(netAmount, rate)
}

export function formatFeePercent(rate) {
  return (effectiveFeeRate(rate) * 100).toLocaleString("es-CL", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
}

export function cardDonateButtonLabel({ netAmount, coverProcessingFee, feeRate, submitting }) {
  if (submitting) return "Procesando…"
  const total = chargeAmount(netAmount, coverProcessingFee, feeRate)
  const formatted = Number(total).toLocaleString("es-CL", { maximumFractionDigits: 0 })
  if (coverProcessingFee && total > netAmount) {
    return `Donar · $${formatted} (incl. comisión)`
  }
  return `Donar · $${formatted}`
}
